import type { SVGProps } from "react";

export function IconDarkBlueGlob(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="24"
        cy="24"
        r="20"
        fill="#63B2FF"
        stroke="black"
        strokeWidth="1.5"
      />
      <mask
        id="mask0_11429_17638"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="40"
        height="40"
      >
        <circle cx="24" cy="24" r="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_11429_17638)">
        <path d="M30 36L36 25L32 19H21V28H26V36H30Z" fill="white" />
        <path d="M23 12V15H34L41 22L49 15L39 0L27 12H23Z" fill="white" />
        <path
          d="M9.14265 32H-6V48H10.9998H15.9998V39L9.14265 32Z"
          fill="white"
        />
        <rect x="-6" y="5" width="17" height="16" fill="white" />
        <circle cx="24" cy="24" r="20" stroke="black" strokeWidth="1.5" />
      </g>
    </svg>
  );
}
